export const dehydrateFormData = (formData: any) => {
	const { controlBucket, testBuckets, websiteName, dashBoardName } = formData;
	const buckets = [...testBuckets, controlBucket];
	return { buckets, websiteName, dashBoardName };
};

export const dehydrateEditFormData = (formData: any) => {
	const { controlBucket, testBuckets, websiteName, dashBoardName, _id } = formData;
	const buckets = [...testBuckets, controlBucket];
	return { buckets, websiteName, dashBoardName, _id };
};
